import BadIcon from 'assets/bad.svg'
import GoodIcon from 'assets/good.svg'
import { clsx } from 'clsx'
import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './PhotoHelpStep.module.scss'

const sela1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-sela-1-5128.jpg'
const sela2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-sela-2-966e.jpg'
const irnby1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-irnby-1-2d84.jpg'
const irnby2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-irnby-2-9bca.jpg'
const photo1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-photo-1-6697.jpg'
const photo2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-photo-2-8253.jpg'

export const PhotoHelpStep = observer(() => {
  const full = store.profile?.type === 'full'
  const src1 = opt.sela ? sela1 : opt.irnby ? irnby1 : photo1
  const src2 = opt.sela ? sela2 : opt.irnby ? irnby2 : photo2

  const onCancel = useLatestCallback(async () => {
    store.profile.step = 'profile'
  })

  const onProfile = useLatestCallback(() => {
    store.profile.step = full ? 'full' : 'profile'
  })

  return <Banner title={i18n('HowToMakeFullbodyPhoto')} onCancel={onCancel}>
    <Typo size={14} secondary>
      {i18n('HowToMakeFullbodyPhotoDescription')}
    </Typo>
    <Gap height={24} />
    <Space gap={16} center>
      <Vertical className={css.cell} gap={12} opposite>
        <Img className={clsx(css.image, opt.square && css.square)} src={src1} />
        <Space gap={8} center>
          <GoodIcon width={16} height={16} />
          <Typo size={14} line={16} medium upper>
            {i18n('Correct')}
          </Typo>
        </Space>
      </Vertical>
      <Vertical className={css.cell} gap={12} opposite>
        <Img className={clsx(css.image, opt.square && css.square)} src={src2} />
        <Space gap={8} center>
          <BadIcon width={16} height={16} />
          <Typo size={14} line={16} medium upper>
            {i18n('Incorrect')}
          </Typo>
        </Space>
      </Vertical>
    </Space>
    <Gap height={24} />
    <Button large primary action={onProfile}>
      {full ? i18n('Continue') : i18n('GotIt')}
    </Button>
  </Banner>
})
